const points = {
    test: 'https://dev-engine.amateum.com/',
    prod: 'https://engine.amateum.com/'
}

export const SENTRY_TRACE_RATE = process.env.NODE_ENV === 'production' ? 1.0 : 0.1
export const ENDPOINT = process.env.NODE_ENV === 'production' ? points[process.env.INSTANCE] || 'https://engine.amateum.com/' : 'http://localhost:3123/'
export const BETS_BASE = process.env.NODE_ENV === 'production' ? 'https://bets.amateum.com/' : 'http://localhost:4000/'
export const FANTASY = 'https://fantasy.amateum.com/'
